///
/// EarthBrowser
///
/// Keyboard shortcuts for the ⌘K command palette:
/// Cmd/Ctrl-K toggles it, Cmd/Ctrl-P opens it.
///
/// Created by Matt Giger on 9/11/2026
/// Copyright (c) 2026 Geodata Labs
///

import { closeCommandPalette, openCommandPalette } from "@/redux/dialogSlice"
import { useAppDispatch, useAppSelector } from "@/redux/store"
import { useEffect } from "react"

export function useCommandPaletteShortcuts() {
	const dispatch = useAppDispatch()
	const isOpen = useAppSelector(state => state.dialog.commandPalette.open)

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			// Don't trigger while typing in an input, textarea, or
			// contenteditable (the palette's own input handles ⌘K itself)
			const target = e.target as HTMLElement
			const isTyping = target.tagName === 'INPUT' ||
							 target.tagName === 'TEXTAREA' ||
							 target.isContentEditable ||
							 target.closest('[contenteditable="true"]')

			if (isTyping) return

			if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
				e.preventDefault()
				dispatch(isOpen ? closeCommandPalette() : openCommandPalette())
			}

			if ((e.metaKey || e.ctrlKey) && e.key === 'p') {
				e.preventDefault()
				if (!isOpen) {
					dispatch(openCommandPalette())
				}
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		return () => document.removeEventListener('keydown', handleKeyDown)
	}, [isOpen, dispatch])
}
